import React, { useState } from "react";
import { PlayIcon } from "./icons";

export default function ReneeSection() {
  const [playing, setPlaying] = useState(false);
  const portrait = "https://customer-assets.emergentagent.com/job_fork-hub-1/artifacts/p7e9i0s7_reneetaylor.jpg";

  return (
    <section data-testid="renee-section" className="relative py-24 md:py-32 bk-glow">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="bk-card rounded-3xl overflow-hidden p-8 md:p-12">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            {/* Bio */}
            <div>
              <span className="text-[11px] uppercase tracking-[0.28em] text-gold/80">
                Featured Endorsement
              </span>
              <h2 className="mt-4 font-display text-4xl md:text-5xl">
                Renée <span className="bk-gold-text italic">Taylor</span>
              </h2>
              <p className="mt-3 text-gold/90 text-sm uppercase tracking-[0.2em]">
                Academy Award Nominee · Emmy Award Winner
              </p>
              <p className="mt-6 text-white/70 leading-relaxed">
                Renée Taylor is a celebrated American actress, writer, and director — famous for
                playing Sylvia Fine, Fran Drescher's mother, on the hit sitcom <em>The Nanny</em>,
                co-writing the film <em>Lovers and Other Strangers</em> (Oscar-nominated), and the
                play <em>My Life on a Diet</em>. A versatile talent known for her comedic timing on
                TV, stage, and film, often collaborating with her late husband, Joe Bologna.
              </p>
              <p className="mt-4 text-sm text-white/55">
                <span className="text-gold/80 font-semibold">Known for:</span> The Nanny · Lovers and Other Strangers · My Life on a Diet
              </p>
            </div>

            {/* Video */}
            <div>
              <div className="relative rounded-2xl overflow-hidden border border-gold/30 aspect-video">
                {playing ? (
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src="https://www.youtube.com/embed/WG7N7GebMVk?autoplay=1&rel=0"
                    title="Testimonial from Renée Taylor"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <button
                    onClick={() => setPlaying(true)}
                    data-testid="renee-play"
                    className="absolute inset-0 w-full h-full group"
                    aria-label="Play Renée Taylor testimonial"
                  >
                    <img src={portrait} alt="Renée Taylor" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="w-20 h-20 rounded-full bk-shimmer flex items-center justify-center text-black shadow-2xl group-hover:scale-110 transition-transform">
                        <PlayIcon className="w-9 h-9 ml-0.5" />
                      </span>
                    </div>
                    <div className="absolute bottom-5 left-5 right-5 text-left">
                      <div className="text-[10px] uppercase tracking-[0.28em] text-gold/90">Testimonial</div>
                      <div className="font-display text-xl md:text-2xl mt-1 text-white">
                        Testimonial from Renée Taylor
                      </div>
                    </div>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
